import { Component,  EventEmitter,  Input, Output } from '@angular/core';
import { LabelObject, Venue } from 'globals/store/events.data';
import { publicHelpers } from './../../helpers/public-helpers';
import { AddToCalComponent } from '../misc/add-to-cal.component';
import { IconComponent } from '../icon/icon.component';
import { LabelsViewComponent } from '../label-marker/labels-view.component';
import { MadeWithJoiComponent } from '../icon/made.with.joi.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'shared-timeline-wrapper',
    template: `
<div class="loading" *ngIf="loading && !unavailable">loading...</div>
<div class="null_screen" *ngIf="unavailable">
  <h1>Sorry!</h1>
  <div>{{ unavailableMessage }}</div>
</div>
<div class="publish-timeline">
  <div *ngIf="!hideTop && (title || description || eventTitle || venue || showExpandContract)" class="publish-header">
    <h1 *ngIf="!!eventTitle" class="event_title">{{ eventTitle }}</h1>
    <h3 *ngIf="isFacilitator && !!title">{{ title }} </h3>
    <div *ngIf="!!roomName">{{ roomName }}</div>
    <div (click)="helpers.openInNewTab('https://www.google.com/maps/place/?q=place_id:' + venue.googleId)" *ngIf="!!venue && !!venue.venue" class="venue-link">
      {{ venue.venue }}<icon [icon]="'OPEN_IN_NEW12'" i12=true></icon>
    </div>
    <add-to-cal *ngIf="shareCode" [canSubscribe]="true" [title]="eventTitle" [eventId]="eventId" [shareCode]="shareCode" [entityType]="'oss'" [entityId]="shareCode" ></add-to-cal>
    <div *ngIf="!isFacilitator && (title || description)" class="publish_info_holder">
      <h2 *ngIf="!!title" class="publish_title">{{ title }}</h2>
      <div [innerHTML]="helpers.strWithBreak(description)" *ngIf="!!description" class="publish_description"></div>
    </div>
    <labels-view *ngIf="!!labelIds?.length" class="title-labels" [labels]="labelIds" [labelMap]="labelMap"></labels-view>
    <div class="extra-filters" *ngIf="!!showExtraFilters">
      <div style="flex:1;"></div>
      <icon [icon]="'grow'" (click)="$event.stopPropagation(); expandAll.emit()"></icon>
      <icon [icon]="'shrink'" (click)="$event.stopPropagation(); collapseAll.emit()"></icon>
    </div>
  </div>
  <ng-content></ng-content>
  <made-with-joi *ngIf="madeWithJoi && !unavailable && !loading" class="madeWithJoi" [ngClass]="{bigBottom: fromShare}"></made-with-joi>
</div>
`,
    styleUrls: ['./shared-timeline-wrapper.scss'],
    standalone: true,
    imports: [AddToCalComponent, IconComponent, LabelsViewComponent, MadeWithJoiComponent, CommonModule],
})
export class SharedTimelineComponent {

  @Input() showExtraFilters = false
  @Input() eventTitle
  @Input() eventId
  @Input() title
  @Input() description
  @Input() shareCode
  @Input() loading = true
  @Input() unavailable = false
  @Input() fromShare = false
  @Input() isFacilitator = false
  @Input() madeWithJoi = true
  @Input() venue: Venue
  @Input() labelIds: string[]
  @Input() labelMap: LabelObject
  @Input() roomName: string
  @Input() hideTop = false
  @Input() unavailableMessage = 'This timeline is currently unavailable.'
  
  @Input() showExpandContract = false

  @Output() expandAll: EventEmitter<void> = new EventEmitter()
  @Output() collapseAll: EventEmitter<void> = new EventEmitter()

  helpers = publicHelpers
  // venueDefault: Partial<Venue> = { venue: "Long Beach", googleId: "ChIJWdeZQOjKwoARqo8qxPo6AKE" }

}


